module.exports = __webpack_public_path__ + "6a2db9f9b31a8116fc57cc8b6b3f324a.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bk-webfont.eot
 ** module id = 370
 ** module chunks = 0
 **/